export const GET_PAYMENTS = 'GET_PAYMENTS';
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const LOAD_PAYMENTS = 'LOAD_PAYMENTS';
export const SET_PAYMENT_FILTER = 'SET_PAYMENT_FILTER';
export const SET_ACTIVE_PAYMENT_TAB = 'SET_ACTIVE_PAYMENT_TAB';
export const GET_PAYMENT_BY_ID = 'GET_PAYMENT_BY_ID';
export const UPDATE_PAYMENT_STATUS = "UPDATE_PAYMENT_STATUS";
export const UPDATE_PAYMENT_METHODS = "UPDATE_PAYMENT_METHODS";
